import React from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { connect } from "react-redux";
import UserBar from "../common/UserBar";
import { availableFeedCardPostTypes } from "../../../../utils/commonVariables";
import CompanyBar from "../common/CompanyBar";
import MetaBar from "../common/MetaBar";
import PostComments from "../common/PostComments";
import { Link } from "react-router-dom";
import {
    GIF_TYPE,
    decodeString,
    getYoutubeThumbnail,
    isYoutubeVideo,
    removeStripTags,
    makePlaylistForJWPlayer,
} from "../../../../utils/helper";
import { certificateLinks, surveyLinks } from "../../../../utils/internalLinks";
import ReadMoreLinkified from "../common/ReadMoreLinkified";
import ReadMoreText from "../common/ReadMoreText";
import PaidRibbon from "../../../../components/profile/MyPassbook/PaidRibbon";
import { left } from "@popperjs/core";
import CommonPlayer from "../../../../components/CommonPlayer";
import CertificateStarGIF from "../../../../assets/images/certifications/certificate-star.gif";
function CertificateCard(props) {
    const {
        cardData,
        isShared,
        showOptionsIcon,
        hideMetaBar,
        isAd,
        showFlagOptions,
        user,
        commentsData,
    } = props,
        { certificate, meta, shared, test_detail } = cardData,
        postId = get(certificate, "id"),
        title = decodeString(certificate.title);
    const linkToCertificate = certificateLinks.viewCertificate(postId);
    const imageToShow = get(certificate, "image", "");
    const isPaid = get(meta, "isPaid", "");
    const date = get(certificate , "test_date", "");
    return (
        <div className="feed-card ">
            <Link to={linkToCertificate} className="certification__card certificate">

                {imageToShow ? (
                    <img
                        src={imageToShow}
                        className={
                            "certification__card__img"
                        }
                        alt={title}
                    />
                ) : null}
                <div className="certification__card__details flex cursor-pointer">
                    <div className="left">
                        {isPaid && (
                            <div className="feedcardribbon__certification__ribbon">
                                <PaidRibbon />
                            </div>
                        )}
                        <ReadMoreLinkified
                            text={title}
                            linksAsDiv={true}
                            className="certification__card__title"
                            hashtagEventLabel="Survey"
                        />
                        <p className="certification__card__subdetails">Issued On: <span>{date}</span></p>
                        <p className="certification__card__subdetails">Validity: <span>{get(certificate, "validity", "")}</span></p>
                    </div>
                    <div className="right">
                        <button className="certification__card__btn certificate-btn cursor-pointer">VIEW CERTIFICATE</button>
                        <img src={CertificateStarGIF} className="img"/>
                    </div>
                </div>
            </Link>
            {!isShared && !hideMetaBar && cardData.meta && (
                <MetaBar
                    postType={availableFeedCardPostTypes.survey}
                    postId={postId}
                    isAd={isAd}
                    likeActionProcessing={cardData.likeActionProcessing}
                    fetchingComments={commentsData && commentsData.fetching}
                    postToShare={cardData}
                    meta={cardData.meta}
                />
            )}
            {commentsData && !hideMetaBar && !isShared && (
                <PostComments
                    showOptionsIcon={showOptionsIcon}
                    commentsData={commentsData}
                    postType={availableFeedCardPostTypes.survey}
                    isAd={isAd}
                    postId={postId}
                />
            )}
        </div>

    )
}


export default CertificateCard;